export default __webpack_public_path__ + "static/media/sl.da5e6211.svg";